var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.001,
    height: 64.001,
    viewBox: "0 0 64.001 64.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload-big-arrow",
    transform: "translate(6.987 -0.154)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30580",
    "data-name": "Rectangle 30580",
    width: 64,
    height: 64,
    transform: "translate(-6.986 0.154)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "exclamation-mark",
    transform: "translate(-6.985 0.154)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-checkmark-circle",
    "data-name": "Icon ionic-ios-checkmark-circle",
    d: "M35.376,3.375a32,32,0,1,0,32,32A32,32,0,0,0,35.376,3.375ZM51.76,26.529,31.191,47.191h-.015a2.778,2.778,0,0,1-1.785.846,2.693,2.693,0,0,1-1.8-.877l-8.616-8.616a.613.613,0,0,1,0-.877l2.739-2.739a.595.595,0,0,1,.862,0l6.831,6.831,18.77-18.908a.607.607,0,0,1,.431-.185h0a.559.559,0,0,1,.431.185l2.692,2.785A.606.606,0,0,1,51.76,26.529Z",
    transform: "translate(-3.377 -3.375)",
    fill: "#24ac21"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckIcon);
export default __webpack_public_path__ + "static/media/green-check-icon.7ffbac448eafdafecd825f7802d9bebf.svg";
export { ForwardRef as ReactComponent };